(() => {
  if (customElements.get('share-icons')) {
    return;
  }

  class ShareIcons extends HTMLElement {
    static ACTIVE_CLASS = 'is-open';

    constructor() {
      super();

      this.onTriggerClick = this.onTriggerClick.bind(this);
    }

    connectedCallback() {
      this.init();
      this.attachEvents();
    }

    disconnectedCallback() {
      this.detachEvents();
    }

    attachEvents() {
      this.triggerButton?.addEventListener('click', this.onTriggerClick);
    }

    detachEvents() {
      this.triggerButton?.removeEventListener('click', this.onTriggerClick);
    }

    init() {
      this.triggerButton = this.querySelector('[data-trigger-button]');
    }

    onTriggerClick() {
      const isOpen = this.hasAttribute('open');

      this.toggleAttribute('open', !isOpen);
    }
  }

  customElements.define('share-icons', ShareIcons);
})();
